import {Box, Container, Grid, Hidden, Theme, Typography, useMediaQuery} from '@material-ui/core';
import {WithStyles, withStyles} from '@material-ui/core/styles';
import {WithTranslation, withTranslation} from 'react-i18next';
import Slider, {Settings} from 'react-slick';

import StartupRocketManMobile from 'src/Assets/Images/startup.png?width=185&height=200&quality=85&ignore';
import StartupRocketMan from 'src/Assets/Images/startup.png?width=305&height=337&quality=85&ignore';
import MoreArrowLink, {IMoreArrowLinkProps} from 'src/Components/Common/Links/MoreArrowLink';
import MessageBalloon from 'src/Components/Common/Sections/MessageBalloon';
import CasesSlide from 'src/Components/Common/Slider/CasesSlide';
import {previewItems} from 'src/Data/Cases/preview-items';
import EnumRoutes from 'src/Routes/EnumRoutes';
import {IAnchorable} from 'src/Routes/Pages/IAnchorable';
import {getRoutePathname} from 'src/Routes/getRoutePathname';

import {startupsBlockStyles} from './startupsBlockStyles';

const StartupsBlock = (props: IStartupsBlockProps) => {
	const matchesMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));
	const settings: Settings = {
		slidesToShow: matchesMobile ? 1.5 : 3,
		variableWidth: false,
		adaptiveHeight: true,
		arrows: false,
		infinite: matchesMobile,
		draggable: false,
		swipe: matchesMobile,
	};

	const moreLinkProps: Partial<IMoreArrowLinkProps> = {
		className: props.classes.moreLink,
		to: getRoutePathname(EnumRoutes.CASES, {language: props.i18n.language}),
	};

	return (
		<section className={props.classes.root} id={props.anchor}>
			<Container maxWidth="lg" disableGutters={matchesMobile}>
				<Grid container spacing={matchesMobile ? 0 : 8}>
					<Grid item sm={12} md={7} className={props.classes.leftGrid}>
						<Hidden smUp>
							<img src={StartupRocketManMobile} className={props.classes.rocketMan} alt={props.t('startup-alt')} />
						</Hidden>
						<Box className={props.classes.leftSide}>
							<MessageBalloon className={props.classes.leftBalloon} arrowOffset={matchesMobile ? 0 : '30%'}>
								<Typography variant="h4" className={props.classes.leftBalloonText}>
									{props.t('title')}
								</Typography>
							</MessageBalloon>
							<MessageBalloon right className={props.classes.rightBalloon} arrowOffset={matchesMobile ? -100 : '10%'}>
								<Typography variant="body2" className={props.classes.rightBalloonText}>
									{props.t('sub-title')}
								</Typography>
							</MessageBalloon>
							<Hidden xsDown>
								<img src={StartupRocketMan} className={props.classes.rocketMan} alt={props.t('startup-alt')} />
							</Hidden>
						</Box>
					</Grid>
					<Grid item container className={props.classes.sliderBoxWrapper} xs={12} md={5}>
						<Grid item xs={5} sm={12}>
							<Typography className={props.classes.sliderBoxTitle} variant="h2">
								{props.t('slider-title')}
							</Typography>
							<Hidden smUp>
								<MoreArrowLink {...moreLinkProps} size="small" />
							</Hidden>
						</Grid>
						<Grid item xs={7} sm={12} className={props.classes.sliderBox}>
							<Slider {...settings}>
								{previewItems.map((item, key) => (
									<CasesSlide
										item={item}
										key={key}
										shouldGrowOnHover={false}
										cardClassName={props.classes.sliderCard}
										sliderCardContentClassName={props.classes.sliderCardContent}
										sliderCardMediaClassName={props.classes.sliderCardMedia}
									/>
								))}
							</Slider>
							<Hidden xsDown>
								<MoreArrowLink {...moreLinkProps} />
							</Hidden>
						</Grid>
					</Grid>
				</Grid>
			</Container>
		</section>
	);
};

interface IStartupsBlockProps extends IAnchorable, WithStyles, WithTranslation {}

export default withStyles(startupsBlockStyles)(withTranslation('startup')(StartupsBlock));
